<p class="one-on-one-chat-message" [class.one-on-one-chat-message--own]="message().isOwn">{{ message().text }}</p>

@if (hasFailed()) {
  <div class="one-on-one-chat-message__meta">
    <span>{{ 'chat.message.error' | transloco }}</span>
    <c-button type="ghost" size="small" [fullWidth]="false" (action)="retry.emit()">
      {{ 'chat.retry' | transloco }}
    </c-button>
  </div>
}
